import { HOME_MADE_RECOMMENDATION_URL } from '../api/constants';
import { getIsClient } from '../common/utils';
import {
  LoadRecommendationsHomemadeType,
  RecoBlockIdTypes,
  RecommendationEventTypes,
} from './types';

export const getCookie = (name: string): string | undefined => {
  if (!getIsClient()) {
    return undefined;
  }
  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1')}=([^;]*)`)
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setCookie = (
  name: string,
  value: string,
  options: { expires: string | number } = { expires: 7 * 24 * 60 * 60 } // 7 days as a fallback
): void => {
  try {
    const optionsObj = {
      ...{ path: '/' },
      ...options,
    };

    if (typeof optionsObj.expires === 'number') {
      const d = new Date();
      d.setTime(d.getTime() + optionsObj.expires * 1000);

      optionsObj.expires = d.toUTCString();
    }

    const newCookie = `${name}=${encodeURIComponent(value)}`;

    const newCookieOptions = Object.entries(optionsObj).reduce(
      (accumulator, [key, newCookieOption]) => `${accumulator}${key}=${newCookieOption};`,
      '; '
    );

    document.cookie = newCookie + newCookieOptions;
  } catch (error) {
    //  console.error(`ERROR setCookie helper: ${error}`);
  }
};

export const deleteCookie = (name: string): void => {
  setCookie(name, '', { expires: -1 });
};

export const getRecommendationsType = (id: RecoBlockIdTypes): RecommendationEventTypes => {
  if (id === 'home-page-tabs') {
    return RecommendationEventTypes.upSellTabs;
  }
  if (id === 'home-page' || id === 'cart-page' || id === 'product-page') {
    return RecommendationEventTypes.upSell;
  }

  return RecommendationEventTypes.crossSell;
};

export const loadRecommendationsHomemade = async ({
  type,
  params,
}: LoadRecommendationsHomemadeType) => {
  let url = HOME_MADE_RECOMMENDATION_URL;
  let options: RequestInit = { method: 'GET' };

  if (type === 'product' && params.productRef && params.colorRef) {
    url += `?id=${params.productRef}-${params.colorRef}`;
  } else if (type === 'home') {
    url += `?page=homepage`;
  } else if (type === 'cart' && params.amount && params.products) {
    options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: 'cart',
        amount: params.amount,
        products: params.products,
      }),
    };
  }

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error('Failed to fetch recommendations');
    }

    const data = await response.json();

    if (!data) {
      return [];
    }
    if (type === 'cart') {
      return data ?? [];
    }

    if (type === 'product') {
      return {
        crossSell: data.crossSellRecommendations ?? [],
        upSell: data.upSellRecommendations ?? [],
      };
    }

    if (type === 'home') {
      return data;
    }

    return null;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to load recommendations');
  }
};
